import { useDispatch, useSelector } from "react-redux";
import { downloadMarginsReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useMarginsReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.clearing.marginsData.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadMarginsReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
